import {put, takeLatest, call} from 'redux-saga/effects';
import * as orderService from "../../../services/orderService";
import {
    REJECT_ORDER,
    REJECT_ORDER_SUCCESS,
    REJECT_ORDER_ERROR,
}
    from "../../actions/order";

function* rejectOrderSaga(action) {
    try {
       const data  = yield call(orderService.RejectOrder,action.payload)
        
       yield put({
        type: REJECT_ORDER_SUCCESS,
        payload: data
    });


    } catch (error) {
        yield put({
            type: REJECT_ORDER_ERROR,error: error.data
        });
    }
}


export function* rejectOrderSagaWatcher() {
    yield takeLatest(REJECT_ORDER, rejectOrderSaga);
}